import axios from 'axios';

const API_TIMEOUT_MS = 30000;
const MAX_RETRIES = 2;

// Use relative paths so API calls always target the current domain (works on any deployment)
const api = axios.create({
  baseURL: '',
  withCredentials: true,
  timeout: API_TIMEOUT_MS,
});

// Track if we're already handling a 401 to avoid cascading redirects
let isHandling401 = false;

// Response interceptor: handle 401 + auto-retry on 5xx/network errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    // Handle 401 Unauthorized — trigger session-expired event
    if (error.response && error.response.status === 401 && !isHandling401) {
      isHandling401 = true;
      window.dispatchEvent(new CustomEvent('auth:session-expired'));
      setTimeout(() => { isHandling401 = false; }, 2000);
      return Promise.reject({ isAuthError: true, message: 'Session expired' });
    }

    // Only retry GET requests on network/5xx errors
    if (
      config &&
      config.method === 'get' &&
      (!config._retryCount || config._retryCount < MAX_RETRIES) &&
      (!error.response || error.response.status >= 500)
    ) {
      config._retryCount = (config._retryCount || 0) + 1;
      const delay = config._retryCount * 1000;
      await new Promise((r) => setTimeout(r, delay));
      return api(config);
    }
    return Promise.reject(error);
  }
);

export default api;
